import(/* webpackMode: "eager" */ "/app/src/app/iframes/charging-v2/[vin]/page.tsx");
